import React from "react";
import { Link } from "react-router-dom";

import btnIcon from "./assets/images/btn-back.svg";

function BtnBack() {
  return (
    <Link to="/plan-update">
      <button className="details__btn-back">
        <img src={btnIcon} alt="Go Back" />
      </button>
    </Link>
  );
}

export default BtnBack;
